module.exports = __webpack_public_path__ + "img/1583.58fe0af4.png";